import { create } from 'zustand';
import {
	ACCESS_TOKEN_STORAGE_KEY,
	USER_STORAGE_KEY,
} from '../constants/auth.constants';
import { type UserEntity } from './../../../shared/types/user.entity';

type AuthState = {
	isAuthenticated: boolean;
	user: UserEntity | null;
	setAuthenticated: (user: UserEntity) => void;
	updateUser: (user: Partial<UserEntity>) => void;
	removeAuthenticated: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
	isAuthenticated: localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) !== null,
	user: localStorage.getItem(USER_STORAGE_KEY)
		? JSON.parse(localStorage.getItem(USER_STORAGE_KEY)!)
		: null,
	setAuthenticated: (user) =>
		set({
			isAuthenticated: true,
			user,
		}),
	removeAuthenticated: () => {
		set({
			isAuthenticated: false,
			user: null,
		});
	},
	updateUser: (user: Partial<UserEntity>) => {
		const newUser = {
			...useAuthStore.getState().user,
			...user,
		} as UserEntity;
		localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(newUser));
		set(() => ({
			user: newUser,
		}));
	},
}));
